const { formatMoney, currencyExchange } = window.BAO.Utils

class ActiveFacets extends window.BAO.CustomElement({
  SuperClass: HTMLDivElement,
}) {
  constructor () {
    super()

    switch (this.dataset.type) {
      case 'search':
        this.eventBus = window.theme.searchResults.eventBus
        this.state = {
          root: window.theme.searchResults?.stateLayer?.state || {
            products: [],
          },
          observer: null,
        }
        break
      case 'autocomplete':
        this.eventBus = window.theme.autocompleteResults.eventBus
        this.state = {
          root: window.theme.autocompleteResults?.stateLayer?.state || {
            products: [],
          },
          observer: null,
        }
        break
      default:
        // Default is collection
        this.eventBus = window.theme.category.eventBus
        this.state = {
          root: window.theme.category?.stateLayer?.state || { products: [] },
          observer: null,
        }
    }
  }

  connectedCallback () {
    this.subscribeToEvents()
    this.populateActiveFacets()
  }

  subscribeToEvents () {
    this.eventBus.subscribe('state:activeFacets:updated', () => {
      this.populateActiveFacets()
    })
  }

  populateActiveFacets () {
    this.state.activeFacets = this.state.root.activeFacets

    this.els['active-facets'].element.innerHTML = ''

    this.state.activeFacets.forEach(facet => {
      if (facet.key === 'klevu_price') {
        this.els['active-facets'].element.insertAdjacentHTML(
          'beforeend',
          this.buildPriceRangeHTML(facet),
        )
      } else {
        facet.values.forEach(value => {
          this.els['active-facets'].element.insertAdjacentHTML(
            'beforeend',
            this.buildHTML(facet, value),
          )
        })
      }
    })

    if (this.state.activeFacets.length > 0) {
      this.els['active-facets'].element.insertAdjacentHTML(
        'beforeend',
        this.buildClearAllHTML(),
      )
    }
  }

  buildPriceRangeHTML (facet) {
    let maxPrice = currencyExchange(facet.values[1] * 100, true)
    let suffix = ''
    if (facet.values[1] >= Number(this.dataset.priceMaxLimit)) {
      maxPrice = Number(this.dataset.priceMaxLimit) * 100
      suffix = '+'
    }

    return `
    <facet-delete data-type="${
      this.dataset.type
    }" class="clc-ProductGridFacetsTablet_ActiveFacet" data-facet="klevu_price" data-value="${
      facet.values[0]
    } - ${facet.values[1]}">
      <button type="button" class="clc-ProductGridFacetsTablet_Active clc-ProductGridFacetsTablet_ActiveLink">
        ${formatMoney(
          currencyExchange(facet.values[0] * 100, false),
        )} - ${formatMoney(maxPrice)}${suffix}
        <svg class="clc-ProductGridFacetsTablet_ActiveLinkSvg" xmlns="http://www.w3.org/2000/svg">
          <use href="#icon-close" />
        </svg>
      </button>
    </facet-delete>
  `
  }

  buildHTML (facet, label) {
    const capitalizedKey =
      facet.key.charAt(0).toUpperCase() + facet.key.slice(1)

    return `
    <facet-delete data-type="${this.dataset.type}" class="clc-ProductGridFacetsTablet_ActiveFacet" data-facet="${capitalizedKey}" data-value="${label}">
      <button type="button" class="clc-ProductGridFacetsTablet_Active clc-ProductGridFacetsTablet_ActiveLink">
        ${label}
        <svg class="clc-ProductGridFacetsTablet_ActiveLinkSvg" xmlns="http://www.w3.org/2000/svg">
          <use href="#icon-close" />
        </svg>
      </button>
    </facet-delete>
  `
  }

  buildClearAllHTML () {
    return `
    <facet-delete-all data-type="${
      this.dataset.type
    }" class="clc-ProductGridFacetsTablet_ActiveFacet" ${
      this.state.activeFacets.length === 0 ? 'disabled' : ''
    }>
      <button type="button" class="clc-ProductGridFacetsTablet_Active clc-ProductGridFacetsTablet_ActiveLink">
        ${window.theme.strings.collection.filters.clearAll}

        <svg class="clc-ProductGridFacetsTablet_ActiveLinkSvg" xmlns="http://www.w3.org/2000/svg">
          <use href="#icon-close" />
        </svg>
      </button>
    </facet-delete-all>
  `
  }
}

window.customElements.define('active-facets', ActiveFacets, {
  extends: 'div',
})
